import { SCREEN_NAMES } from 'src/constants/screenNames';

/**
 * 未割当リストの表示単位（伝票 / 地点）の localStorage キー。画面ごとに分ける。
 *
 * もともとは 3 画面で 1 本のキーを共有していた。トグルを出すのが `/map` だけで、
 * 他の 2 画面は保存値を無視して伝票単位に固定していたので実害が無かった。
 * log_web_issues#338 C8 でカード配車と長距離にもトグルを出したため、共有のままだと
 * 地図で地点単位にしただけで他の 2 画面も地点単位になる。中央に置くもの（地図・カード・
 * 日付ボード）が違えば、ちょうどよい見せ方も画面ごとに変わる（ユーザー判断 2026-09-25）。
 *
 * Why not すべて新しいキーにする: `/map` は唯一トグルを出していた画面で、利用者が選んだ
 * 値が入っている。キーを変えると全員が伝票単位に戻る。`/map` だけ元のキーを使い続ける。
 */
const LEGACY_SHARED_KEY = 'dispatch.unassigned.displayMode';

export function displayModeStorageKey(screenName: string): string {
  if (screenName === SCREEN_NAMES.PLANNING_LONG_HAUL) return `${LEGACY_SHARED_KEY}.longHaul`;
  if (screenName === SCREEN_NAMES.CONVENIENCE_DISPATCHES) return `${LEGACY_SHARED_KEY}.convenience`;
  // `/map` と、画面名を渡していない呼び出し元は従来のキーのまま
  return LEGACY_SHARED_KEY;
}
